const useStyles = theme => ({
    container: {
      position: 'relative',
      overflow: 'hidden',
      height: 280
    },
    playButtonArrow: {
      position: 'absolute',
      left: '50%',
      top: '50%',
      transform: 'translate(-50%, -50%)',
      alignSelf: 'top',
    },
    previewImage: {
      overflow: 'hidden',
      objectFit: 'cover',
      height: '100%',
      width: '100%',
    },
    gradientBox: {
      opacity: 0.3,
      zIndex: 1,
      position: 'absolute',
      height: '100%',
      width: '100%',
      background: 'linear-gradient(to bottom, rgba(0,0,0,0.1), black)',
    },
    durationBox: {
      bottom: '5px',
      right: '5px',
      position: 'absolute',
      zIndex: 2
    },
    playButton: {
      zIndex: 2,
      position: 'absolute',
      height: '47px',
      width: '47px',
      borderRadius: 25,
    },
});

export default useStyles
